import { Compass, Clock, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

export function HowItWorks() {
  const { t } = useTranslation();
  const steps = [
    { icon: Compass, title: t("how.steps.discoverTitle"), desc: t("how.steps.discoverDesc") },
    { icon: Clock, title: t("how.steps.timeTitle"), desc: t("how.steps.timeDesc") },
    { icon: Zap, title: t("how.steps.bookTitle"), desc: t("how.steps.bookDesc") },
  ];
  return (
    <section id="how" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <div className="text-xs font-semibold uppercase tracking-widest text-primary">{t("how.eyebrow")}</div>
        <h2 className="mt-3 text-balance font-display text-4xl font-bold tracking-tight sm:text-5xl">
          {t("how.title")}
        </h2>
        <p className="mt-4 text-balance text-muted-foreground">{t("how.subtitle")}</p>
      </div>

      <div className="mt-16 grid gap-6 lg:grid-cols-3">
        {steps.map((step, i) => (
          <div
            key={step.title}
            className="group relative overflow-hidden rounded-3xl border border-border bg-card p-8 shadow-soft transition-all hover:-translate-y-1 hover:shadow-elevated"
          >
            <div className="absolute end-6 top-6 font-display text-7xl font-bold text-muted/60">
              0{i + 1}
            </div>
            <div className="relative">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-glow">
                <step.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
